import type { SxProps, Theme } from '@mui/material'

export const expandControlIconButtonSx: SxProps<Theme> = {
  color: 'text.secondary',
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'primary.main',
  },
}
